import ContactUs from "@/components/views/ContactUs";

export default [
  {
    path: "/contact_us",
    name: "contact",
    component: ContactUs
  }
];
